"use strict";

var checkoutaddressapp = new Vue({
  el: "#checkoutaddressapp",
  components: {
    Autocomplete: Autocomplete
  },
  data: function data() {
    return {
      pick_up_only: 0,
      billing_and_shipping_same: 1,
      here_api_key: '',
      billing_address_first_name: "",
      billing_address_last_name: "",
      billing_address_email: "",
      billing_address_phone: "",
      billing_address_company: "",
      billing_address_line1: "",
      billing_address_line2: "",
      billing_address_postcode: "",
      billing_address_city: "",
      billing_address_country: "",
      billing_address_state: "",
      shipping_address_first_name: "",
      shipping_address_last_name: "",
      shipping_address_email: "",
      shipping_address_phone: "",
      shipping_address_company: "",
      shipping_address_line1: "",
      shipping_address_line2: "",
      shipping_address_postcode: "",
      shipping_address_city: "",
      shipping_address_country: "",
      shipping_address_state: ""
    };
  },
  created: function created() {
    var thisapp = this;
    axios.get('/cms/sell/cart/checkoutInfo').then(function (result) {
      thisapp.here_api_key = result.data.here_api_key;
      thisapp.billing_address_first_name = result.data.billing_address_first_name;
      thisapp.billing_address_last_name = result.data.billing_address_last_name;
      thisapp.billing_address_email = result.data.billing_address_email;
      thisapp.billing_address_phone = result.data.billing_address_phone;
      thisapp.billing_address_company = result.data.billing_address_company;
      thisapp.billing_address_line1 = result.data.billing_address_line1;
      thisapp.billing_address_line2 = result.data.billing_address_line2;
      thisapp.billing_address_postcode = result.data.billing_address_postcode;
      thisapp.billing_address_city = result.data.billing_address_city;
      thisapp.billing_address_country = result.data.billing_address_country;
      thisapp.billing_address_state = result.data.billing_address_state;
      thisapp.shipping_address_first_name = result.data.shipping_address_first_name;
      thisapp.shipping_address_last_name = result.data.shipping_address_last_name;
      thisapp.shipping_address_email = result.data.shipping_address_email;
      thisapp.shipping_address_phone = result.data.shipping_address_phone;
      thisapp.shipping_address_company = result.data.shipping_address_company;
      thisapp.shipping_address_line1 = result.data.shipping_address_line1;
      thisapp.shipping_address_line2 = result.data.shipping_address_line2;
      thisapp.shipping_address_postcode = result.data.shipping_address_postcode;
      thisapp.shipping_address_city = result.data.shipping_address_city;
      thisapp.shipping_address_country = result.data.shipping_address_country;
      thisapp.shipping_address_state = result.data.shipping_address_state;

      if (!thisapp.billing_address_line1) {
        // Read from local storage
        var localdata = JSON.parse(localStorage.getItem('cogcheckoutaddress'));

        if (localdata) {
          thisapp.billing_address_first_name = localdata.billing_address_first_name;
          thisapp.billing_address_last_name = localdata.billing_address_last_name;
          thisapp.billing_address_email = localdata.billing_address_email;
          thisapp.billing_address_phone = localdata.billing_address_phone;
          thisapp.billing_address_company = localdata.billing_address_company;
          thisapp.billing_address_line1 = localdata.billing_address_line1;
          thisapp.billing_address_line2 = localdata.billing_address_line2;
          thisapp.billing_address_postcode = localdata.billing_address_postcode;
          thisapp.billing_address_city = localdata.billing_address_city;
          thisapp.billing_address_country = localdata.billing_address_country;
          thisapp.billing_address_state = localdata.billing_address_state;
          thisapp.shipping_address_first_name = localdata.shipping_address_first_name;
          thisapp.shipping_address_last_name = localdata.shipping_address_last_name;
          thisapp.shipping_address_email = localdata.shipping_address_email;
          thisapp.shipping_address_phone = localdata.shipping_address_phone;
          thisapp.shipping_address_company = localdata.shipping_address_company;
          thisapp.shipping_address_line1 = localdata.shipping_address_line1;
          thisapp.shipping_address_line2 = localdata.shipping_address_line2;
          thisapp.shipping_address_postcode = localdata.shipping_address_postcode;
          thisapp.shipping_address_city = localdata.shipping_address_city;
          thisapp.shipping_address_country = localdata.shipping_address_country;
          thisapp.shipping_address_state = localdata.shipping_address_state;
        }
      }
    });
  },
  watch: {
    billing_address_first_name: 'saveToLocalStorage',
    billing_address_last_name: 'saveToLocalStorage',
    billing_address_email: 'saveToLocalStorage',
    billing_address_phone: 'saveToLocalStorage',
    billing_address_company: 'saveToLocalStorage',
    billing_address_line1: 'saveToLocalStorage',
    billing_address_line2: 'saveToLocalStorage',
    billing_address_postcode: 'saveToLocalStorage',
    billing_address_city: 'saveToLocalStorage',
    billing_address_country: 'saveToLocalStorage',
    billing_address_state: 'saveToLocalStorage',
    shipping_address_first_name: 'saveToLocalStorage',
    shipping_address_last_name: 'saveToLocalStorage',
    shipping_address_email: 'saveToLocalStorage',
    shipping_address_phone: 'saveToLocalStorage',
    shipping_address_company: 'saveToLocalStorage',
    shipping_address_line1: 'saveToLocalStorage',
    shipping_address_line2: 'saveToLocalStorage',
    shipping_address_postcode: 'saveToLocalStorage',
    shipping_address_city: 'saveToLocalStorage',
    shipping_address_country: 'saveToLocalStorage',
    shipping_address_state: 'saveToLocalStorage'
  },
  methods: {
    saveToLocalStorage: function saveToLocalStorage() {
      localStorage.setItem('cogcheckoutaddress', JSON.stringify({
        billing_address_first_name: this.billing_address_first_name,
        billing_address_last_name: this.billing_address_last_name,
        billing_address_email: this.billing_address_email,
        billing_address_phone: this.billing_address_phone,
        billing_address_company: this.billing_address_company,
        billing_address_line1: this.billing_address_line1,
        billing_address_line2: this.billing_address_line2,
        billing_address_postcode: this.billing_address_postcode,
        billing_address_city: this.billing_address_city,
        billing_address_country: this.billing_address_country,
        billing_address_state: this.billing_address_state,
        shipping_address_first_name: this.shipping_address_first_name,
        shipping_address_last_name: this.shipping_address_last_name,
        shipping_address_email: this.shipping_address_email,
        shipping_address_phone: this.shipping_address_phone,
        shipping_address_company: this.shipping_address_company,
        shipping_address_line1: this.shipping_address_line1,
        shipping_address_line2: this.shipping_address_line2,
        shipping_address_postcode: this.shipping_address_postcode,
        shipping_address_city: this.shipping_address_city,
        shipping_address_country: this.shipping_address_country,
        shipping_address_state: this.shipping_address_state
      }));
    },
    here_api_key: window.here_api_key,
    search: function search(input) {
      var _this = this;

      return new Promise(function (resolve) {
        if (input.length < 5) {
          return resolve([]);
        }

        axios.get("https://autosuggest.search.hereapi.com/v1/autosuggest?at=-27,153&apiKey=".concat(_this.here_api_key, "&q=").concat(input)).then(function (result) {
          if (!result.data) {
            return resolve([]);
          }

          if (!result.data.items) {
            return resolve([]);
          }

          if (!result.data.items.length) {
            return resolve([]);
          }

          resolve(result.data.items);
        });
      });
    },
    // We want to display the title
    getResultValue: function getResultValue(result) {
      return result.title;
    },
    handleSubmitBilling: function handleSubmitBilling(result) {
      var _this2 = this;

      axios.get("https://lookup.search.hereapi.com/v1/lookup?apiKey=".concat(this.here_api_key, "&id=").concat(result.id)).then(function (result) {
        _this2.billing_address_line1 = result.data.address.houseNumber + ' ' + result.data.address.street;
        _this2.billing_address_city = result.data.address.district;
        _this2.billing_address_postcode = result.data.address.postalCode;
        _this2.billing_address_state = result.data.address.state;
        _this2.billing_address_country = result.data.address.countryName;
      });
    },
    handleSubmitShipping: function handleSubmitShipping(result) {
      var _this3 = this;

      axios.get("https://lookup.search.hereapi.com/v1/lookup?apiKey=".concat(this.here_api_key, "&id=").concat(result.id)).then(function (result) {
        _this3.shipping_address_line1 = result.data.address.houseNumber + ' ' + result.data.address.street;
        _this3.shipping_address_city = result.data.address.district;
        _this3.shipping_address_postcode = result.data.address.postalCode;
        _this3.shipping_address_state = result.data.address.state;
        _this3.shipping_address_country = result.data.address.countryName;
      });
    }
  }
});